// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import { createHook, createStore } from '@atlassian/react-sweet-state';
import actions from './actions/index.tsx';
import type { ReportsNavState, ReportsNavActions } from './types.tsx';

export const initialState: ReportsNavState = {
	data: {
		customReports: [],
	},
};

const Store = createStore<ReportsNavState, ReportsNavActions>({
	name: 'reports-nav-jsd',
	initialState,
	actions,
});

export const useReportsNavApi = createHook(Store);

export default Store;
